import set from 'lodash/set';
import get from 'lodash/get';
import formatAdventurerName from 'src/common/utils/format-adventurer-name';

export const DISPLAY_DRAWER_KEY = 'inputValue';

export const createValues = (drawerKey, productCustomisation, autocapitaliseInputs) => {
  let values = { base: '' , drawerKey };
  let value = get(productCustomisation, drawerKey);

  value = autocapitaliseInputs ? formatAdventurerName(value) : value;

  // use dummy key so we don't need to deal with nested objects when updating.
  set(values, DISPLAY_DRAWER_KEY, value);

  // we need to take into account if the custom key is for a nested object
  // e.g. drawerKey = characters[0].name.   initialKey = 'characters'
  // then we just get the 'characters' array from the customistaion.
  // if the drawer key is 'name' then inital key will also be 'name' and everything works
  // ok -
  const initialKey = drawerKey.match(/[^\]\[.]+/g)[0];
  const customisationValues = { [initialKey] : productCustomisation[initialKey] };

  return ({
    ...values,
    ...customisationValues,
  });
};

// We use the display key to show the info on the page - on submit we map the displayed value to
// the drawer key we are using in the customisation.  This key can be quite complex hence (see tests)
export const updateValuesFromDisplayKey =  (values, autocapitaliseInputs = false) => {
  autocapitaliseInputs &&  (values[DISPLAY_DRAWER_KEY] = formatAdventurerName(values[DISPLAY_DRAWER_KEY]));

  set(values, values.drawerKey, values[DISPLAY_DRAWER_KEY]);

  return values;
};
